<template>
	<div id="topAD" class="topAD">
		<img class="fr" :src="imgPath+'close_b.png'" @click="closeAD">
		<a :href="topObj.jump_url" class="fr" :style="'color:'+topObj.btn_clor+';border-color:'+topObj.btn_clor">{{topObj.btn_text}}</a>
		<img v-if="topObj.pic_url" class="logo" :src="topObj.pic_url">
		<img v-else src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/logo/logo_red1024x388.png">
	</div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';

export default {
	data() {
		return {
			imgPath:'',
		}
	},
	props:['topObj'],
	mounted() {
		this.imgPath = tool.imgPath();
	},
	methods: {
		closeAD(){
			this.$emit('closeAD');
		}
	}
}
</script>

<style scoped>
.topAD {
	height: 24px;
	line-height: 24px;
	padding: 7px;
	overflow: hidden;
	background: #1c2744;
	color: #ed2203;
}

.topAD img {
	height: 24px;
}

.topAD a {
	display: block;
	border: 1px solid #eb2203;
	border-radius: 12px;
	height: 22px;
	line-height: 22px;
	font-size: 12px;
	padding: 0 12px;
	margin-right: 10px;
}
</style>